import information from '@/views/mainContent/information'
import basemenu from '@/views/mainContent/information/base'
import addForm from "../views/mainContent/information/addForm";
import score from "../views/mainContent/information/score";
import fujian from "../views/mainContent/information/fujian";
import gaishu from '../views/mainContent/information/gaishu'
import xiangmu from '../views/mainContent/information/xiangmu'
import gaikuang from '../views/mainContent/information/gaikuang'
import users from '../views/mainContent/information/user'
import adduser from '../views/mainContent/information/user/listNew/index'
import otherfile from '@/views/mainContent/information/otherfile'
import ranking from '@/views/mainContentCentral/statisticalQuery/ranking'
import { getStorage} from "@/utils";
let standardManageRouter = {
  path: '/informationDeclaration',
  component: information,
  exact: true,
  children:  [
    { //基本信息
      path: '/informationDeclaration/museumbaseinfo/base',
      component: basemenu,
      exact: true,
    },
    { //基本信息
      path: '/informationDeclaration/museumbaseinfo/baseProvince',
      component: basemenu,
      exact: true,
    },
    { //博物馆活动项目
      path: '/informationDeclaration/museumbaseinfo/activity',
      component: xiangmu,
      exact: true,
    },
    { //博物馆活动项目
      path: '/informationDeclaration/museumbaseinfo/activityProvince',
      component: xiangmu,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/develop',
      component: gaikuang,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/developProvince',
      component: gaikuang,
      exact: true,
    },
    { //附件汇总
      path: '/informationDeclaration/annex',
      component: fujian,
      exact: true,
    },
    { //附件汇总
      path: '/informationDeclaration/annexCentral',
      component: fujian,
      exact: true,
    },
    { //附件汇总
      path: '/informationDeclaration/annexProvince',
      component: fujian,
      exact: true,
    },
    { //附件汇总
      path: '/informationDeclaration/annexScore',
      component: fujian,
      exact: true,
    },
    { //评分详情
      path: '/informationDeclaration/scoredetail',
      component: score,
      exact: true,
    },
    { //评分详情
      path: '/informationDeclaration/scoredetailProvince',
      component: score,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/resource',
      component: gaishu,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/resourceProvince',
      component: gaishu,
      exact: true,
    },
    { //用户管理
      path: '/user',
      component: users,
      exact: true,
    },
    { //用户管理
      path: '/informationDeclaration/adduser',
      component: adduser,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfile',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileCentral',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileScore',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/otherfileProvince',
      component: otherfile,
      exact: true,
    }
  ]
}
function computedData(data){
  data.forEach(item=>{
    if (item.name === '博物馆数据') {
      if (item.children) {
        item.children.forEach(item1=>{
          if (item1.children){
            item1.children.forEach(item2=>{
              if (item2.children){
                item2.children.forEach(item3=>{
                  standardManageRouter.children.push(
                      { //基本信息
                        path: item3.rule,
                        component: addForm,
                        exact: true,
                      },
                  )
                })
              }
            })
          }
        })
      }
    } else if (item.name === '查询统计'){
      if (item.children) {
        item.children.forEach(item1=>{
          if (item1.type === 'tables'){
            standardManageRouter.children.push(
                { //基本信息
                  path: item1.rule,
                  component: ranking,
                  exact: true,
                },
            )
          }
          if (item1.children){
            item1.children.forEach(item2=>{
              if (item2.type === 'tables'){
                standardManageRouter.children.push(
                    { //基本信息
                      path: item2.rule,
                      component: ranking,
                      exact: true,
                    },
                )
              }
            })
          }
        })
      }
    }
  })
}
const login = sessionStorage.getItem('login')
if (login) {
  var menu = JSON.parse(localStorage.getItem('menu'))
  if (menu && menu.length > 0) {
    computedData(menu)
  }
}
export default standardManageRouter
